import { useFetcher } from '@remix-run/react'
import {
	PROFILE_ADDRESSES_FORM_REMOVE_ADDRESS,
	PROFILE_ADDRESSES_INPUTS,
} from '~/routes/($lang).profile.addresses/addresses.component'

type useOptimisticRemoveAddressProps = {
	id: number
}

function useOptimisticRemoveAddress({ id }: useOptimisticRemoveAddressProps) {
	const removeAddressFetcher = useFetcher({
		key: PROFILE_ADDRESSES_FORM_REMOVE_ADDRESS.generateFetcherKey!({
			id: String(id),
		}),
	})

	return (
		removeAddressFetcher.formData?.get(
			PROFILE_ADDRESSES_INPUTS.removeAddress,
		) === id.toString()
	)
}

export { useOptimisticRemoveAddress }
